/**
 * Internal Lithuanian text shaping for TTS.
 * Does not change UI copy, only the string sent to synthesis.
 */
export function preprocessLithuanianText(text) {
  if (!text || text.length === 0) return text;

  // Historical syllable-splitting (e.g. "labas" -> "la bas") was tuned for a
  // model that gave Lithuanian strong Romance phonetics; on eleven_v3 those
  // artificial splits pushed pronunciation toward Spanish. Preprocessing now
  // only ensures terminal punctuation so the model knows the phrase has ended.
  let processed = text;

  if (processed && !processed.match(/[.!?;:,]$/)) {
    processed += '.';
  }

  return processed;
}
